import { ApplicationRef, ComponentRef, ɵglobal as global } from '@angular/core';
import { Router } from '@angular/router';
import { DebugHelperService } from '@shared/services/debug-helper.service';

export const NEQTO_DEBUG_GLOBAL_NAME = 'debug';

export function enableNeqtoDebugTools<T>(ref: ComponentRef<T>): ComponentRef<T> {
  exportNeqtoVar(NEQTO_DEBUG_GLOBAL_NAME, new NeqtoDebugger(ref));

  return ref;
}

export function exportNeqtoVar(name: string, value: any): void {
  const neqto = (global.neqto = (global.neqto as { [key: string]: any } | undefined) || {});

  neqto[name] = value;
}

export class NeqtoDebugger {
  #appRef: ApplicationRef;
  #router: Router;
  #debugHelperService: DebugHelperService;

  constructor(ref: ComponentRef<any>) {
    this.#appRef = ref.injector.get(ApplicationRef);
    this.#router = this.#appRef.injector.get(Router);
    this.#debugHelperService = this.#appRef.injector.get(DebugHelperService);
  }

  showFlowIds(): void {
    if (this.#router.url.match(/^\/flow\/[0-9]+$/)) {
      this.#debugHelperService.setShowIds(true);
    }
  }

  hideFlowIds(): void {
    this.#debugHelperService.setShowIds(false);
  }
}
